import React, { useEffect, useState } from 'react'
import { getMaestroPaquetesQx } from '../../../services/Clinico'
import ModalCrearMaestroPaquetesQx from './ModalCrearMaestroPaquetesQx'
import ModalModificarMaestroPaquetesQx from './ModalModificarMaestroPaquetesQx'
import { useLocation } from "react-router-dom";
import axios from "axios";
import { UserTokenURL } from '../../../services/ApiHIS';
import Loading from '../../Loading';
import ModalConsultarMaestroPaquetesQx from './ModalConsultarMaestroPaquetesQx';
import ModalEliminarSuministrosYPaqueteQx from './ModalEliminarSuministrosYPaqueteQx';

const PaquetesQuirurgicosPrincipal = () => {
  const [dataPaquetes, setdataPaquetes]=useState([])
  const [modalOnCrearPaquetesQx, setmodalOnCrearPaquetesQx]=useState(false)
  const [modalOnModificarPaquetesQx, setmodalOnModificarPaquetesQx]=useState(false)
  const [dataUnPaquete, setdataUnPaquete]=useState('')
  const [actuliazarDataPaqueteQx, setactuliazarDataPaqueteQx]=useState('')
  const [loading, setloading]=useState(true)
  const [selectCheckboxMaestroPaquetesQx, setselectCheckboxMaestroPaquetesQx]=useState(null)
  const [modalOnConsultar, setmodalOnConsultar]=useState(false)
  const [modalOnEliminarPaqueteQx, setmodalOnEliminarPaqueteQx]=useState(false)

  //token
  let query = new URLSearchParams(useLocation().search);
  let tokenCons = JSON.parse(query.get("token"));
  let location = useLocation();
  useEffect(() => {
    // Google Analytics
    //localStorage.removeItem('tokenReact');
    localStorage.setItem("tokenReact", tokenCons);
  }, [location]);


  useEffect(()=>{    
    setloading(false)
    setselectCheckboxMaestroPaquetesQx(null)
    setdataUnPaquete('')
    getMaestroPaquetesQx().then((res)=>{  
      setloading(true)    
      setdataPaquetes(res.data.data)
    })   
  },[actuliazarDataPaqueteQx])

  const handleOnsubmitFiltro=(e)=>{
    e.preventDefault()
    const filtro={
      "PaqCod": e.target.codigo.value,
      "PaqDes": e.target.descripcion.value,
      "PaqIndAct": e.target.estado.value,
    }
    getMaestroPaquetesQx(filtro).then((res)=>{      
      setdataPaquetes(res.data.data)
    })   
  }

  const handleOnclickCreate=()=>{
    setmodalOnCrearPaquetesQx(true)
  }

  const handleOnclickUpdate=()=>{
    if(dataUnPaquete){
      setmodalOnModificarPaquetesQx(true)
    }
    
  }

  const handleOnclickConsultar=()=>{
    if(dataUnPaquete){
      setmodalOnConsultar(true)
    }
  }

  const handleOnclickDelete=()=>{
    if(dataUnPaquete){
      setmodalOnEliminarPaqueteQx(true)
    }
  }

 
  const handleCheboxMaestroPaquetesQx=(item)=>{
    setselectCheckboxMaestroPaquetesQx(item.PaqCod)
    setdataUnPaquete(item)
  }

  //token
  useEffect(() => {
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL(); 

    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };

    // Realiza la petición con Axios
    axios
      .get(url, { headers })
      .then((response) => {
        //console.log(response.data.user_data, 'data user');

        // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
        localStorage.removeItem("usuarioInfo");
        //console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
        // Guarda los nuevos datos
        localStorage.setItem(
          "usuarioInfo",
          JSON.stringify(response.data.user_data)
        );

        //console.log(localStorage.getItem('usuarioInfo'),'antessss')
        // Comprobación de los datos almacenados
        const usuarioInfo = JSON.parse(localStorage.getItem("usuarioInfo"));
        //console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr gestion')

        // Resto del código...
      })
      .catch((error) => {
        console.error("Error al autenticar al usuario:", error);
        //seterrorEndpoint(true)
      });
  }, []);
  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#05a29d] font-medium pb-3">
          Maestro de Creación de Paquetes Quirúrgicos
        </div>

        <form onSubmit={handleOnsubmitFiltro}>
          <div className="flex ">
            <div className="mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Codigo
              </label>
              <div className="flex">
                <input
                  name="codigo"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            <div className="mb-3 xl:w-96 px-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Descripción
              </label>
              <div className="flex">
                <input
                  name="descripcion"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
                
              </div>
            </div>
            <div  className="mb-3 xl:w-96 pl-2">
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium " >
                     Estado
                </label>
                <div className="flex">
                <select className="form-select block  w-full px-2 py-0.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example " 
                //defaultValue={dataUser.ProSit}
                //value={opcion}
                //onChange={handleOnchangeOpcion} 
                name='estado'
                >
                                         
                                        <option value="">Sin seleccionar</option>
                                        <option value="S">Activo</option>
                                        <option value="N">Inactivo</option>
                                        
                                    </select>
                                    <div className="px-3">
                  <button
                    type="submit"
                    className="inline-block px-6 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Buscar
                  </button>
                </div>
                </div>
            </div>
          </div>
        </form >
        <div className="flex ">
          
        <button
        onClick={handleOnclickCreate}
        type="button"
        className="inline-block px-6 py-1.5 bg-violet-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-violet-700 hover:shadow-lg focus:bg-violet-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-violet-800 active:shadow-lg transition duration-150 ease-in-out"
      >
        Crear
      </button>
      
      <div className='px-2'>
      <button
                  onClick={handleOnclickUpdate}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Modificar 
                </button>
      </div>
      <div className='px-2'>
      <button
                  onClick={handleOnclickConsultar}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-yellow-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-yellow-700 hover:shadow-lg focus:bg-yellow-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-yellow-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Consultar
                </button>      
      </div>
      <div className='px-2'>
      <button
                  onClick={handleOnclickDelete}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Eliminar
                </button>
      </div>
      {/* <div className='px-2'>
      <button
        onClick={handleOnclicExcelFormasLiquidacion}
        type="button"
        className="inline-block px-6 py-1.5 bg-green-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out"
      >
        Excel
      </button>      
      </div> */}
      </div>
        <div className="flex flex-col">
          <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-auto md:overflow-visible">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                      <th></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >                        
                      </th>                      
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Codigo
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Descripción
                      </th>     
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Indicador
                      </th>     
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Tipo paquete
                      </th>     
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Activo?
                      </th>     
                    </tr>
                  </thead>                  
                  <tbody >
                  {loading ? (
                    dataPaquetes.map((item,index)=>(
                      <tr className=" divide-y divide-slate-700 " key={index}>
                        <td></td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                          <div className="topping">
                            <input
                              type="checkbox"
                              checked={selectCheckboxMaestroPaquetesQx === item.PaqCod}
                              onChange={() => handleCheboxMaestroPaquetesQx(item)}
                            />                          
                          </div>
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                          {item.PaqCod}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
                          {item.PaqDes}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                          {item.PaqInd === 'P'? 'Paquetes': (item.PaqInd === 'G'? 'Generico': item.PaqInd)}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                          {item.PaqTip === 'Q'? 'Quirurgicos':(item.PaqTip === 'N'? 'No quirurgicos':item.PaqTip)}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                          {item.PaqIndAct === 'S'? 'Si':'No'}
                        </td>
                      </tr>
                    ))
                  ) : (                    
                      <tr className="divide-y divide-slate-700 ">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <Loading />
                        </td>
                        <td></td>
                      </tr>
                  )}
                   </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOnCrearPaquetesQx? <ModalCrearMaestroPaquetesQx setmodalOnCrearPaquetesQx={setmodalOnCrearPaquetesQx} setactuliazarDataPaqueteQx={setactuliazarDataPaqueteQx}/>:null}
      {modalOnModificarPaquetesQx? <ModalModificarMaestroPaquetesQx setmodalOnModificarPaquetesQx={setmodalOnModificarPaquetesQx} dataUnPaquete={dataUnPaquete} setactuliazarDataPaqueteQx={setactuliazarDataPaqueteQx}/>:null}
      {modalOnConsultar? <ModalConsultarMaestroPaquetesQx setmodalOnConsultar={setmodalOnConsultar} dataUnPaquete={dataUnPaquete}/>:null}
      {modalOnEliminarPaqueteQx? <ModalEliminarSuministrosYPaqueteQx setmodalOnEliminarPaqueteQx={setmodalOnEliminarPaqueteQx} dataUnPaquete={dataUnPaquete} setactuliazarDataPaqueteQx={setactuliazarDataPaqueteQx}/>:null}
      
    </>
  )
}

export default PaquetesQuirurgicosPrincipal